module.exports = __webpack_public_path__ + "static/media/multi1.7713b5e4.png";